import { useContext } from "react";
import { ParameterDeclarationContext } from "search-filter/logic/ParameterDeclarationProvider";
const useParameterDeclarationContext = () => useContext(ParameterDeclarationContext);
export default useParameterDeclarationContext;
